import { BaseModel } from "@blue-chip/core";
import Project from "./Project";
import Person from "./Person";

export default class Contact extends BaseModel {
  static get belongsTo() {
    return [Project, Person];
  }
}
